(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:pinMeOnVerticalScroll
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <pin-me-on-vertical-scroll></pin-me-on-vertical-scroll>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('pinMeOnVerticalScroll', pinMeOnVerticalScroll);

    function pinMeOnVerticalScroll(EventManagerService) {
        return {
            restrict: 'A',
            replace: false,
            controllerAs: 'pinMeOnVerticalScroll',
            link: function (scope, element, attrs) {
                var elementClientRect = angular.element(element)[0].getBoundingClientRect(),
                    oriHeight = elementClientRect.height;

                element.css({'position': 'absolute'});
                angular.element(element).parent().css({'position': 'relative'});

                var dummy = angular.element('<div class="dummy-item">');
                dummy.addClass(element.attr('class'));
                dummy.css({'width': '0px', 'height': oriHeight + 'px'});
                element.after(dummy);

                EventManagerService.registerEventListener(EventManagerService.EVENT.SCROLL.SCROLL_TOP_CHANGE, function (param) {
                    element.css({'top': param + 'px','z-index': '10'});
                });
            }
        };
    }
}());
